










import Vue from "vue";
import { Component } from "vue-property-decorator";
import ReportTable from "@/components/ReportTable.vue";
import { columnDateTimeFormatter } from "@/utils/CommonUtils";
import Layout from "@/components/Layout.vue";
import { GridAggFunction } from "@/grid/gridConstants";
import PageHeader from "@/components/PageHeader.vue";

@Component({
	components: { PageHeader, Layout, ReportTable },
})
export default class RefundReportPage extends Vue {
	// see chp.d_ContributionType for cont1 - cont8 description
	private columnDefs = [
		{
			field: "employerName",
			rowGroup: true,
			hide: true,
			resizable: true,
			menuTabs: ["generalMenuTab"],
			columnsMenuParams: {
				suppressColumnFilter: false,
				suppressColumnExpandAll: false,
				suppressColumnSelectAll: false,
			},
		},
		{
			field: "reportingCentre",
			resizable: true,
			rowGroup: true,
			hide: true,
		},
		{
			field: "presentationRefTotalAmount",
			resizable: true,
			rowGroup: true,
			hide: true,
		},
		{
			headerName: "Fund",
			field: "fund",
			minWidth: 160,
		},
		{
			headerName: "Employee",
			field: "employeeName",
			resizable: true,
			minWidth: 160,
		},
		{
			headerName: "Paid",
			headerTooltip: "Paid Effective Date",
			field: "effectiveDate",
			resizable: true,
			valueFormatter: columnDateTimeFormatter,
			minWidth: 115,
		},
		{
			headerName: "From",
			headerTooltip: "Period Start Date",
			field: "periodStart",
			valueFormatter: columnDateTimeFormatter,
			resizable: true,
			minWidth: 115,
		},
		{
			headerName: "To",
			headerTooltip: "Period End Date",
			field: "periodEnd",
			valueFormatter: columnDateTimeFormatter,
			resizable: true,
			minWidth: 115,
		},
		{
			headerName: "Batch ID",
			headerTooltip: "Batch ID",
			field: "batchId",
			resizable: true,
			minWidth: 115,
		},
		{
			headerName: "Super Guarantee",
			field: "superGuarantee",
			resizable: true,
			aggFunc: GridAggFunction.SUM_OF_CURRENCY,
			minWidth: 115,
		},
		{
			headerName: "Salary Sacrifice",
			field: "salarySacrifice",
			resizable: true,
			aggFunc: GridAggFunction.SUM_OF_CURRENCY,
			minWidth: 115,
		},
		{
			headerName: "Award",
			field: "award",
			resizable: true,
			aggFunc: GridAggFunction.SUM_OF_CURRENCY,
			minWidth: 115,
		},
		{
			headerName: "Personal",
			field: "personal",
			resizable: true,
			aggFunc: GridAggFunction.SUM_OF_CURRENCY,
			minWidth: 115,
		},
		{
			headerName: "Employer Voluntary",
			field: "employerVoluntary",
			resizable: true,
			aggFunc: GridAggFunction.SUM_OF_CURRENCY,
			minWidth: 115,
		},
		{
			headerName: "Spouse",
			field: "spouse",
			resizable: true,
			aggFunc: GridAggFunction.SUM_OF_CURRENCY,
			minWidth: 115,
		},
		{
			headerName: "Child",
			field: "child",
			resizable: true,
			aggFunc: GridAggFunction.SUM_OF_CURRENCY,
			minWidth: 115,
		},
		{
			headerName: "Other 3rd Party",
			field: "otherThirdParty",
			resizable: true,
			aggFunc: GridAggFunction.SUM_OF_CURRENCY,
			minWidth: 115,
		},
	];
}
